import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, CURRENT_ENV } from '../../../../utils';
import {
  APP_ID,
  APP_VERSION,
} from '../../../../utils/constants/request-related';

let bucketName = '';
const prodEnvEnums = [
  'STAGING',
  'PRODUCTION',
  'GOOGLE-SPOT-PREPROD',
  'GOOGLE-SPOT-PROD',
];
if (prodEnvEnums.includes(CURRENT_ENV)) {
  bucketName = `esdoc`;
} else {
  bucketName = `esqadoc-qa`;
}

export const BNK_STMT_s3FileUpload_API_CALL = createAsyncThunk(
  'BNK_STMT_s3FileUpload_API_CALL',
  async (s3SaveFileReqPayload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'BNK_STMT_s3FileUpload_API_CALL/pending', payload: {} });
    const { payload, index, successFn, errorFn } = s3SaveFileReqPayload;
    const {
      Authorization,
      customerId,
      customerRefNum,
      folder_name,
      file_name,
      inputStream,
    } = payload;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/s3savefilenew',
      payload: {
        customerRefNum,
        s3SaveFileDetails: {
          bucket_name: bucketName,
          folder_name,
          file_name,
          inputStream,
        },
        // content_type: 'application/pdf',
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const s3SaveFileResponse = res;
        console.log({ response: s3SaveFileResponse, index });
        dispatch({
          type: 'BNK_STMT_s3FileUpload_API_CALL/fulfilled',
          payload: { response: s3SaveFileResponse, index },
        });
        if (successFn) successFn();
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'BNK_STMT_s3FileUpload_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const BNK_STMT_s3FileUpload_API_CALL_extrareducer = {
  [BNK_STMT_s3FileUpload_API_CALL.pending]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = true;
  },
  [BNK_STMT_s3FileUpload_API_CALL.fulfilled]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = true;
    state.s3FileUploadAPICall.isError = false;
    if (action.payload) {
      const { response, index } = action.payload;
      console.log('action payload: ', { s3FileResponse: response, index });
      state.s3FileUploadAPICall.response = response;
      const uploadFileResponsesLocal = [
        ...state.s3FileUploadAPICall.uploadFileResponses,
      ];
      uploadFileResponsesLocal[index] = response.body.fileUploadInfo;
      console.log({ uploadFileResponsesLocal });
      state.s3FileUploadAPICall.uploadFileResponses = [
        ...uploadFileResponsesLocal,
      ];
    }
  },
  [BNK_STMT_s3FileUpload_API_CALL.rejected]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = false;
    state.s3FileUploadAPICall.isError = true;
    state.s3FileUploadAPICall.response = action.payload;
  },
};
